import React, { useReducer } from "react";
import findBrand from "../../components/findBrand";
import axios from "axios";
import moment from "moment";
import setAuthToken from "../../functions/auth_header";
import RegistrationContext from "./registrationContext";
import RegistrationReducer from "./registrationReducer";
import ErrorLogger from "../../components/ErrorLogger";
import { toast } from "react-toastify";
import {
  GET_AGE,
  GET_SITE_INFORMATION,
  GET_SITE_PROGRAM,
  GET_BRAND_DATA,
  LEVEL_DOWN,
  LEVEL_UP,
  ON_FORM_DATA_CHANGE,
  ON_ZIP_SEARCH_CHANGE,
  SET_PASS,
  SET_LOADING,
  GET_ZIP_SITES,
  SUBMIT_DATA,
} from "../types";
import { getAppUrl, getLocationApiUrl } from "../../functions/getEnv";

const RegistrationState = (props) => {
  const initialState = {
    formData: {
      progressLevel: 0,
      processingLevel: 0,
      registerForIntercession: false,
      previouslyEnrolled: "",
      firstName: "",
      middleName: "",
      lastName: "",
      haveSuffix: "",
      suffix: "",
      gender: "",
      birthDate: "",
      age: "",
      gradeLevel: "",
      schooldistrictofresidence: "",
      birthState: "",
      birthCountry: "",
      studentEmail: "",
      // schooldistrictofresidence: "",
      studentPrimaryPhone: "",
      studentPrimaryPhoneType: "",
      studentName: "",
      preferredpronouns: "",
      otherpreferredpronouns: "",
      pgHighestLevelOfEducation: "",
      permissionParentContact: { yes: false, no: false },
      pgRelationshipToStudent: "",
      pgFirstName: "",
      pgLastName: "",
      pgPrimaryPhone: "",
      pgPrimaryPhoneType: "",
      pgPrimaryEmail: "",
      liveWithPg: "",
      livingStatus: "",
      pg2HighestLevelOfEducation: "",
      pg2RelationshipToStudent: "",
      pg2FirstName: "",
      pg2LastName: "",
      pg2PrimaryPhone: "",
      pg2PrimaryPhoneType: "",
      pg2PrimaryEmail: "",
      liveWithPg2: "",
      livingStatus2: "",
      liveinUS: "",
      street: "",
      city: "",
      state: "",
      zip: "",
      county: "",
      addressfield: "",
      mailingaddressfield: "",
      isMailingAddressTheSame: "",
      mailingStreet: "",
      mailingCity: "",
      mailingState: "",
      mailingZip: "",
      isStudentHispanicOrLatino: "",
      primaryRaceCategory: "",
      previousSchool: "",
      previousSchoolCity: "",
      previousSchoolState: "",
      primaryLanguage: "",
      firstLanguage: "",
      homeLanguage: "",
      languageSpokenByParentsToStudent: "",
      languageSpokenByAdultsAtHome: "",
      isPgEmployedInOneOrMoreAgriculturalOrFishingActivities: "",
      releaseAudioAndVideo: "",
      releasePermissionForSocialMedia: "",
      releaseUseStudentWork: "",
      releasePermissionToTextStudent: "",
      releasePermissionToTextPg: "",
      releaseAllowStudentAccessToGoogleAppsForEducation: "",
      beenExpelled: "",
      expelledFromWhichSchool: "",
      expelledWhatYear: "",
      beenSuspended: "",
      suspendedFromWhichSchool: "",
      suspendedWhatYear: "",
      onProbation: "",
      isParentOrExpecting: "",
      moreThanThreeUnexcusedAbsences: "",
      lateToSchoolMoreThanThreeTimes: "",
      orderedToAttendSchool: "",
      orderedToAttendWhichSchool: "",
      orderedToAttendWhatYear: "",
      retainedMoreThanOnce: "",
      retainedFromWhichSchool: "",
      retainedFromWhatYear: "",
      droppedOutOfSchool: "",
      droppedOutFromWhichSchool: "",
      droppedOutFromWhatYear: "",
      behindSemesterInCredits: "",
      outOfSchoolMoreThanFortyFiveDays: "",
      expelledMoreThanTwoSchoolsPastYear: "",
      fosterCare: "",
      youthExperiencingHomelessness: "",
      accessToComputerAtHome: "",
      accessToTheInternetAtHome: "",
      knownHealthConditions: "",
      asthma: "",
      beeStingAllergy: "",
      diabetes: "",
      epilepsy: "",
      heartCondition: "",
      seizures: "",
      nutAllergy: "",
      knownHearingConditions: "",
      wearsHearingAid: "",
      knownEyeCondition: "",
      glassesToBeWornAtAllTimes: "",
      wearsContactLenses: "",
      wearsGlasses: "",
      medications: "",
      otherHealthCondition: "",
      medicalInstructions: "",
      heathInsuranceCarrier: "",
      insuranceIdOrPolicyNumber: "",
      hospitalPreference: "",
      custodyIssueExists: "",
      custodyIssueNotes: "",
      legalRestrictionsForAnyParent: "",
      legalRestrictionsNotes: "",
      emergencyContact1FirstName: "",
      emergencyContact1LastName: "",
      emergencyContact1Phone: "",
      emergencyContact1Relationship: "",
      authorizedForPickup1: "",
      emergencyContact2FirstName: "",
      emergencyContact2LastName: "",
      emergencyContact2Phone: "",
      emergencyContact2Relationship: "",
      authorizedForPickup2: "",
      learningCenterId: "",
      learningCenterName: "",
      learningCenterCharter: "",
      learningCenterAddress: "",
      _uuid:"",

      orientationScheduled: false,
      orientationType: "",
      orientationTime: "",
      orientationLink: "",
      brandIcon: "",
      principal: "",
    },
    pass: {
      studentInformation: true,
      studentPreference: true,
      parentInformation: true,
      parent2Information: true,
      physicalAddress: true,
      address1: true,
      ethnicity: true,
      previousSchool1: true,
      primarylangauage: true,
      releaseRequests: true,
      homelanguage: true,
      migrantEducation1: true,
      homesurvey: true,
      emergencyContacts: true,
      dassInformation1: true,
      healthConditions: true,
      parentCustody: true,
    },
    subFormLevels: {
      enrollmentType: 0,
      studentInformation: 0,
      studentPreference: 0,
      parentInformation: 0,
      parent2Information: 0,
      physicalAddress: 0,
      ethnicity: 0,
      releaseRequests: 0,
      dassInformation: 0,
      healthConditions: 0,
      parentCustody: 0,
      emergencyContacts: 0,
    },
    formLevel: 0,
    siteInformation: {},
    Siteprogram: {},
    learningCenterCoordinates: {},
    zipSearch: {
      zipcode: "",
      radius: 15,
    },
    zipSites: [],
    zipCoordinates: {},
    loading: false,

    preSelected: false,
    charterBrandName: "Learn4Life",
  };

  const [state, dispatch] = useReducer(RegistrationReducer, initialState);

  /* const apiUrl =
    import.meta.env.MODE === `production` ? `` : `http://localhost:5000`; */

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const locationApiUrl = getLocationApiUrl(import.meta.env.VITE_NODE_ENV);

  // console.log('RegistrationState');
  // console.log('appUrl:', appUrl);
  // console.log('locationApiUrl:', locationApiUrl);

  const getSiteInformation = async (id) => {
    try {
      const res = await axios.get(
        `${locationApiUrl
        /* process.env.NODE_ENV === `production`
          ? `https://llac-locations-api.azurewebsites.net`
          : `http://localhost:7000` */
        }/enrollment-site/${id}`
      );
      dispatch({ type: GET_SITE_INFORMATION, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const subLevelUp = (name) => {
    const subLevelCaps = {
      studentInformation: 0,
      studentPreference: 0,
      parentInformation: 0,
      parent2Information: 0,
      physicalAddress: 0,
      ethnicity: 0,
      releaseRequests: 0,
      dassInformation: 0,
      healthConditions: 0,
      parentCustody: 0,
      emergencyContacts: 0,
    };
    dispatch({
      type: "SUB_LEVEL_UP",
      payload: { name, cap: subLevelCaps[name] },
    });
  };

  const selectEnrollmentType = (type) => {
    dispatch({ type: "SELECT_ENROLLMENT_TYPE", payload: type });
  };

  const subLevelDown = (name) => {
    dispatch({ type: "SUB_LEVEL_DOWN", payload: { name } });
  };

  const levelUp = () => {
    dispatch({ type: LEVEL_UP });
  };

  const levelDown = () => {
    dispatch({ type: LEVEL_DOWN });
  };

  const setPass = (name, value) => {
    dispatch({ type: SET_PASS, payload: { name, value } });
  };

  const setLearningCenter = (data) => {
    dispatch({ type: "SET_LEARNING_CENTER", payload: data });
  };

  const onFormDataChange = (e) => {
    dispatch({
      type: ON_FORM_DATA_CHANGE,
      payload: {
        name: e.target.name,
        value:
          e.target.type === "radio"
            ? e.target.name === "previouslyEnrolled"
              ? e.target.value === "yes"
                ? { yes: true, no: false, "not sure": false }
                : e.target.value === "no"
                  ? { yes: false, no: true, "not sure": false }
                  : { yes: false, no: false, "not sure": true }
              : e.target.value === "yes"
                ? { yes: true, no: false }
                : { yes: false, no: true }
            : e.target.value,
      },
    });
  };

  const getAge = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var newAge = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      newAge--;
    }
    dispatch({ type: GET_AGE, payload: newAge });
  };
  const onZipSearchChange = (e) => {
    dispatch({
      type: ON_ZIP_SEARCH_CHANGE,
      payload: {
        name: e.target.name,
        value: e.target.value,
      },
    });
  };

  const setLanguageToEnglish = () => {
    dispatch({ type: "SET_TO_ENGLISH" });
  };

  const setLoading = (bool) => {
    dispatch({ type: SET_LOADING, payload: bool });
  };

  const getZipLocations = async (zip, radius) => {
    try {
      dispatch({ type: SET_LOADING, payload: true });
      const res = await axios.get(
        `${locationApiUrl
        /* process.env.NODE_ENV === `production`
          ? `https://llac-locations-api.azurewebsites.net`
          : `http://localhost:7000` */
        }/sites-distance/${zip}/${radius}`
      );

      dispatch({ type: GET_ZIP_SITES, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error);
    }
  };

  const getSiteprogram = async (id) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      // console.log('Access Token:',userAccessToken);
      setAuthToken(userAccessToken);

      const res = await axios.get(
        `${locationApiUrl
        /* process.env.NODE_ENV === `production`
          ? `https://llac-locations-api.azurewebsites.net`
          : `http://localhost:7000` */
        }/enrollment-site-program/${id}`
      );

      dispatch({ type: GET_SITE_PROGRAM, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const getSitBrand = async (brandName) => {
    try {
      const authRes = await axios.get(`${appUrl}/auth/webapp`);
      const userAccessToken = authRes.data.accessTokens[0];
      // console.log('Access Token:',userAccessToken);
      setAuthToken(userAccessToken);

      const res = await axios.get(
        `${locationApiUrl
        /* process.env.NODE_ENV === `production`
          ? `https://llac-locations-api.azurewebsites.net`
          : `http://localhost:7000` */
        }/sites-bybrand/${brandName}`
      );

      dispatch({ type: GET_BRAND_DATA, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const submitData = async (data) => {
    try {
      //  const currURL = window.location.href;
      //const site_id = currURL.slice(-24);
      //data.learningCenterId = site_id;
      if (!data.learningCenterId) {
        // Fallback: try to get from URL if not already in data
        const urlParams = new URLSearchParams(window.location.search);
        const siteId = urlParams.get('site');
        if (siteId) {
          data.learningCenterId = siteId;
        }
      }

      // UUID generation function
      const generateRealUUID = () => {
        if (crypto && crypto.randomUUID) {
          return crypto.randomUUID();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      };

      // Use existing UUID from data if available (from copy enrollment link), otherwise generate new one
      const uuidToUse = data._uuid || generateRealUUID();
      //console.log('Registration UUID being used:', uuidToUse, '- Source:', data._uuid ? 'Existing (Copy Enrollment Link)' : 'Newly Generated');

      // Add UUID to data before submitting
      const submissionData = {
        ...data,
        _uuid: uuidToUse
      };

      const res = await axios.post(`${appUrl}/api/registration/`, submissionData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      //console.log("Registration API Response:", res.data);
      const registrationRecordId = res.data._uuid;
      sendRegistrationEmail(data, registrationRecordId);

      toast.success("Registration submitted successfully!", { autoClose: 2000 });

      dispatch({ type: SUBMIT_DATA });

    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
      toast.error("Registration submission failed. Please try again.", { autoClose: 2000 });
    }
  };

  const preSelectedSite = (siteString) => {
    try {
      dispatch({ type: "PRE_SELECTED_SITE", payload: siteString });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const charterPreSelected = (charterString) => {
    try {
      dispatch({ type: "PRE_SELECTED_CHARTER", payload: charterString });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const charter = (charters) => {
    try {
      dispatch({ type: "CHARTER", payload: charters });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const sendRegistrationEmail = async (data, registrationRecordId) => {
    try {
      const id1=data.learningCenterId;
      //console.log("Id ",id1)
      // const currURL = window.location.href;
      // const id = currURL.slice(-24);
      // data.learningCenterId = id;

      const siteDetailsResponse = await axios.get(
        `${locationApiUrl}/enrollment-site-program/${id1}`
      );

      const site = siteDetailsResponse.data;

      const principalPerson = site.people.find(
        (person) =>
          person.category === "LEADERSHIP" &&
          person.role_match &&
          person.role_match.name === "Principal"
      );

      const emailData = {
        name: `${data.firstName} ${data.middleName} ${data.lastName}`,
        pgName: `${data.pgFirstName} ${data.pgLastName}`,
        studentEmail: data.studentEmail,
        charterContactnumber: site.charter.charterContactnumber,
        brandIcon: site.charter.brand.brandIcon,
        brandPhoto: site.charter.brand.brandPhoto,
        learningCenterName: site.name,
        learningCenterCharter: site.charter.name,
        learningCenterAddress: `${site.address.address_1}, ${site.address.city}, ${site.address.state}, ${site.address.zip}`,
        charterWebsite: site.charter.charterWebsite,
        principal: principalPerson ? principalPerson.person.name : "Unassigned",
        learningCenterId: `${data.learningCenterId}`,
        brandName: site.charter.brand.brandName,
        EnrollmentsUrl: site.charter.brand.EnrollmentsUrl,
        domain: site.charter.brand.domain,
        registrationEmail: site.enrollment_info.registrationEmail,
        registrationRecordId: registrationRecordId, // Add registration record ID
      };
// console.log("emailData",emailData)
      const res = await axios.post(
        `${appUrl}/api/email/register-email`,
        emailData
      );
      const res1 = await axios.post(
        `${appUrl}/api/email/register-notification-email`,
        emailData
      );
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  return (
    <RegistrationContext.Provider
      value={{
        formData: state.formData,
        formLevel: state.formLevel,
        subFormLevels: state.subFormLevels,
        siteInformation: state.siteInformation,
        Siteprogram: state.Siteprogram,
        filter: state.filter,
        learningCenterCoordinates: state.learningCenterCoordinates,
        zipSearch: state.zipSearch,
        zipSites: state.zipSites,
        zipCoordinates: state.zipCoordinates,
        loading: state.loading,
        pass: state.pass,
        intialFilledOut: state.intialFilledOut,
        parentsInfoFilledOut: state.parentsInfoFilledOut,
        parents2InfoFilledOut: state.parents2InfoFilledOut,
        getEmailFilledOut: state.getEmailFilledOut,
        addressFiledOut: state.addressFiledOut,
        mailingFiledOut: state.mailingFiledOut,
        preSelected: state.preSelected,
        charterBrandName: state.charterBrandName,
        charter: state.charter,
        intialFilledOut1: state.intialFilledOut1,
        studentPreferenceFilled: state.studentPreferenceFilled,
        parentsInfo: state.parentsInfo,
        parents2Info: state.parents2Info,
        addressinfo: state.addressinfo,
        mailingAddressfilled: state.mailingAddressfilled,
        ethicityFilledout: state.ethicityFilledout,
        previousSchooldetails: state.previousSchooldetails,
        primaryLanguagefilledout: state.primaryLanguagefilledout,
        homeLanguage1: state.homeLanguage1,
        migrantEducation2: state.migrantEducation2,
        migrantEdu: state.migrantEdu,
        relaseRequest: state.relaseRequest,
        // homeSurvey:state.homeSurvey,
        homeSuvey: state.homeSuvey,
        emergencyContact: state.emergencyContact,
        dassInformation2: state.dassInformation2,
        ParentCustody: state.ParentCustody,
        intialFilledOut2: state.intialFilledOut2,

        setLearningCenter,
        onFormDataChange,
        getAge,
        setPass,
        setLanguageToEnglish,
        onZipSearchChange,
        getZipLocations,

        setLoading,
        submitData,
        preSelectedSite,
        charterPreSelected,
        getSiteInformation,
        getSiteprogram,
        levelUp,
        levelDown,
        subLevelUp,
        subLevelDown,
        selectEnrollmentType,
        sendRegistrationEmail,
        getSitBrand,
      }}>
      {props.children}
    </RegistrationContext.Provider>
  );
};

export default RegistrationState;
